import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClientsBySeller } from '../../Redux/Actions/actions';
import styles from './ClientSelector.module.css';

const ClientSelector = ({ selectedClients = [], onSelectionChange, sellerId }) => {
  const dispatch = useDispatch();
  const { clientsBySeller, clientsLoading, clientsError } = useSelector(state => state);
  const [searchTerm, setSearchTerm] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (sellerId) {
      // Cargar solo clientes activos
      dispatch(getClientsBySeller(sellerId, { activo: 'true' }));
    }
  }, [sellerId, dispatch]);

  const handleClientToggle = (client) => {
    const isSelected = selectedClients.some(selected => selected.id === client.id);
    let newSelection;
    
    if (isSelected) {
      // Remover propietario de la selección
      newSelection = [];
    } else {
      // Solo permitir un propietario (reemplazar selección anterior)
      newSelection = [client];
    }
    
    onSelectionChange(newSelection);
  };

  const filteredClients = clientsBySeller.filter(client => 
    client.activo && // Solo clientes activos
    (client.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
     client.apellido.toLowerCase().includes(searchTerm.toLowerCase()) ||
     client.mail.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (!sellerId) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>Seleccionar Cliente</h3>
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className={styles.toggleButton}
        >
          {isExpanded ? '▼' : '▶'} 
          {selectedClients.length > 0 && (
            <span className={styles.count}>(Propietario seleccionado)</span>
          )}
        </button>
      </div>

      {isExpanded && (
        <div className={styles.content}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="Buscar propietario..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
          </div>

          {clientsLoading && (
            <div className={styles.loading}>
              <div className={styles.spinner}></div>
              <span>Cargando clientes...</span>
            </div>
          )}

          {clientsError && (
            <div className={styles.error}>
              Error al cargar clientes: {clientsError}
            </div>
          )}

          {!clientsLoading && filteredClients.length === 0 && (
            <div className={styles.empty}>
              {searchTerm ? 'No se encontró ningún propietario con ese criterio' : 'No tienes propietarios registrados'}
            </div>
          )}

          <div className={styles.clientList}>
            {filteredClients.map(client => {
              const isSelected = selectedClients.some(selected => selected.id === client.id);
              
              return (
                <div
                  key={client.id}
                  className={`${styles.clientCard} ${isSelected ? styles.selected : ''}`}
                  onClick={() => handleClientToggle(client)}
                >
                  <div className={styles.clientInfo}>
                    <div className={styles.clientName}>
                      {client.nombre} {client.apellido}
                    </div>
                    <div className={styles.clientDetails}>
                      <span className={styles.email}>📧 {client.mail}</span>
                      <span className={styles.phone}>📞 {client.telefono}</span>
                      {client.categoria && (
                        <span className={styles.category}>🏷️ {client.categoria}</span>
                      )}
                    </div>
                  </div>
                  <div className={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleClientToggle(client)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          {selectedClients.length > 0 && (
            <div className={styles.selectedSummary}>
              <h4>Propietario Seleccionado:</h4>
              <div className={styles.selectedList}>
                {selectedClients.map(client => (
                  <span key={client.id} className={styles.selectedTag}>
                    {client.nombre} {client.apellido}
                    <button
                      type="button"
                      onClick={() => handleClientToggle(client)}
                      className={styles.removeButton}
                    >
                      ✕
                    </button>
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClientSelector;